module.exports = __webpack_public_path__ + "static/30-547c3be2c4af815bdea4a3f8cad050c9.jpg";